import { cn } from "@/lib/utils";

interface ListeningPlaceholderProps {
  className?: string;
}

export const ListeningPlaceholder = ({ className }: ListeningPlaceholderProps) => {
  return (
    <div
      className={cn(
        "barca-chat-listening-placeholder bw-rounded-2xl bw-p-2 bw-backdrop-blur-sm bw-shadow-sm bw-ml-auto bw-w-fit",
        "bw-bg-blue-600/90 bw-border bw-border-blue-600/30 bw-shadow-lg bw-shadow-blue-600/20",
        "animate-fade-in",
        className
      )}
    >
      <div className="bw-flex bw-items-center bw-gap-1 bw-px-2 bw-py-1">
        <div className="bw-w-1.5 bw-h-1.5 bw-bg-white bw-rounded-full bw-animate-bounce" style={{ animationDelay: '0ms' }} />
        <div className="bw-w-1.5 bw-h-1.5 bw-bg-white bw-rounded-full bw-animate-bounce" style={{ animationDelay: '150ms' }} />
        <div className="bw-w-1.5 bw-h-1.5 bw-bg-white bw-rounded-full bw-animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  );
};
